export default __webpack_public_path__ + "static/media/banner-image-2.6d7b69f3.jpg";